import React, { useEffect } from "react"
import { Phone, Clock, Star, Trophy, Sparks } from "iconoir-react"
import { useNavigate } from "react-router-dom"
import Loading from "../Loading"

interface MobileSplashPageProps {
  isAuthenticated?: boolean
  isLoading?: boolean
}

export const MobileSplashPage: React.FC<MobileSplashPageProps> = ({ isAuthenticated = false, isLoading = false }) => {
  const navigate = useNavigate()

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/dashboard")
    }
  }, [isAuthenticated, navigate])

  const handleGetStarted = () => {
    localStorage.clear()
    window.location.href = "/signup"
  }

  const handleLogin = () => {
    localStorage.clear()
    window.location.href = "/dashboard"
  }

  if (isLoading) {
    return <Loading />
  }

  return (
    <div className="flex flex-col items-center justify-between h-screen bg-linear-to-b from-purple-50 to-indigo-50 p-6 overflow-hidden pt-safe">
      <div className="grow flex flex-col justify-around">
        {/* Logo */}
        <div className="w-full flex justify-center mt-6">
          <img src="/vibrato-logo-alt.svg" alt="Vibrato" className="h-12" />
        </div>

        {/* Hero Section */}
        <div className="flex flex-col items-center justify-center text-center w-full">
          {/* Value Points */}
          <div className="space-y-4 mb-10 w-full  max-w-xs md:max-w-md">
            <div className="flex items-center space-x-3 p-4 bg-white rounded-xl transform transition-all shadow-md hover:shadow-lg w-full">
              <div className="w-10 h-10 rounded-full bg-linear-to-r from-purple-500 to-indigo-600 flex items-center justify-center shrink-0">
                <Clock className="h-5 w-5 text-white" />
              </div>
              <span className="text-gray-800 font-medium">Skip the hold music forever</span>
            </div>

            <div className="flex items-center space-x-3 p-4 bg-white rounded-xl transform transition-all shadow-md hover:shadow-lg w-full">
              <div className="w-10 h-10 rounded-full bg-linear-to-r from-blue-500 to-cyan-500 flex items-center justify-center shrink-0">
                <Star className="h-5 w-5 text-white" />
              </div>
              <span className="text-gray-800 font-medium">Lower bills automatically</span>
            </div>

            <div className="flex items-center space-x-3 p-4 bg-white rounded-xl transform transition-all shadow-md hover:shadow-lg w-full">
              <div className="w-10 h-10 rounded-full bg-linear-to-r from-amber-500 to-orange-500 flex items-center justify-center shrink-0">
                <Trophy className="h-5 w-5 text-white" />
              </div>
              <span className="text-gray-800 font-medium">Monitor calls live & in control</span>
            </div>

            <div className="flex items-center space-x-3 p-4 bg-linear-to-r from-blue-500 to-cyan-600 rounded-xl transform transition-all shadow-md hover:shadow-lg w-full">
              <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center shrink-0">
                <Sparks className="h-5 w-5 text-white" />
              </div>
              <span className="text-white font-medium text-left">Join 10,000+ people saving time on calls</span>
            </div>
          </div>
        </div>
      </div>
      {/* CTA Buttons */}
      <div className="w-full max-w-xs md:max-w-md space-y-3 mx-auto">
        <button
          onClick={handleGetStarted}
          className="w-full py-4 px-6 bg-linear-to-r from-purple-600 to-indigo-600 text-white font-medium rounded-xl shadow-lg hover:shadow-xl transition-all duration-200 flex items-center justify-center gap-2"
        >
          <Phone className="w-5 h-5" />
          Get Started Now
        </button>
        <button
          onClick={handleLogin}
          className="w-full py-4 px-6 bg-white hover:bg-gray-50 text-purple-600 font-medium rounded-xl border border-purple-200 shadow-md hover:shadow-lg transition-all duration-200"
        >
          Log In
        </button>
      </div>
    </div>
  )
}
